export const generateData = () => {
    const dt = new Date();

    return new Date(dt.setMonth(dt.getMonth() + 3)).toUTCString();
};
